import { DEFAULT_RATE_SCHEDULE } from 'src/app/pages/agreements/constants/rate-schedule.constants';
import { TimeBlock } from 'src/app/shared/graphql/graphql-types';

/**
 * The array of possible agreement rate time blocks sorted by pick order.
 *
 * rateSchedule: The exact rateSchedule matching the timeBlock (i.e. by day and time)
 * rateScheduleByDay: The rateSchedule that matches only the day of the timeBlock; this is used for matching against
 * indicative rates which currently is refined by day only, and not by time.
 * default: Flagger to indicate whether the timeBlock is added to a new agreement by default.
 */
export const AGREEMENT_RATE_TIME_BLOCKS = [
  {
    timeBlock: TimeBlock.WeekdayDaytime,
    name: 'Weekday daytime',
    description: 'Starts and/or ends 6 am - 8 pm',
    rateSchedule: { ...DEFAULT_RATE_SCHEDULE, weekday: true, daytime: true },
    rateScheduleByDay: { ...DEFAULT_RATE_SCHEDULE, weekday: true },
    default: true,
  },
  {
    timeBlock: TimeBlock.WeekdayEvening,
    name: 'Weekday evening',
    description: 'Starts and/or ends 8 pm - midnight',
    rateSchedule: { ...DEFAULT_RATE_SCHEDULE, weekday: true, evening: true },
    rateScheduleByDay: { ...DEFAULT_RATE_SCHEDULE, weekday: true },
    default: false,
  },
  {
    timeBlock: TimeBlock.WeekdayOvernight,
    name: 'Weekday overnight active',
    description: 'Starts and/or ends midnight - 6 am',
    rateSchedule: { ...DEFAULT_RATE_SCHEDULE, weekday: true, overnight: true },
    rateScheduleByDay: { ...DEFAULT_RATE_SCHEDULE, weekday: true },
    default: false,
  },
  {
    timeBlock: TimeBlock.Saturday,
    name: 'Saturday',
    description: null,
    rateSchedule: { ...DEFAULT_RATE_SCHEDULE, saturday: true },
    rateScheduleByDay: { ...DEFAULT_RATE_SCHEDULE, saturday: true },
    default: true,
  },
  {
    timeBlock: TimeBlock.Sunday,
    name: 'Sunday',
    description: null,
    rateSchedule: { ...DEFAULT_RATE_SCHEDULE, sunday: true },
    rateScheduleByDay: { ...DEFAULT_RATE_SCHEDULE, sunday: true },
    default: true,
  },
  {
    timeBlock: TimeBlock.PublicHoliday,
    name: 'Public Holiday',
    description: null,
    rateSchedule: { ...DEFAULT_RATE_SCHEDULE, publicHoliday: true },
    rateScheduleByDay: { ...DEFAULT_RATE_SCHEDULE, publicHoliday: true },
    default: true,
  },
] as const;

export type RateTimeBlock = (typeof AGREEMENT_RATE_TIME_BLOCKS)[number];
